import React from 'react'
import { observer } from 'mobx-react-lite'
import { Switch } from 'shared/ui'
import { TitledRow } from 'shared/ui/TitledRow/TitledRow'
import { type IActiveCampaignSettingsDict } from 'entities/Integrations'
import { IntegrationSyncDropdown } from 'pages/settings/pages/integrations/pages/integrationSettings/ui/IntegrationSyncDropdown/IntegrationSyncDropdown'
import { type IntegrationSettingsSyncStore } from 'pages/settings/pages/integrations/pages/integrationSettings/store/IntegrationSettingsSyncStore'
import {
  getContactCreation,
  getPropertySync,
} from 'pages/settings/pages/integrations/pages/integrationSettings/lib'
import styles from './styles.module.scss'

type IIntegrationActiveCampaignSettingsSyncProps = {
  store: IntegrationSettingsSyncStore<IActiveCampaignSettingsDict>
}

export const IntegrationActiveCampaignSettingsSync = observer(
  ({ store }: IIntegrationActiveCampaignSettingsSyncProps) => {
    const {
      isTwoWaySync,
      setSyncType,
      syncType,
      setCheckbox,
      getCheckbox,
      selectItems,
      integrationName,
    } = store

    const CHECKBOXES = [
      getPropertySync('update_contacts', integrationName),
      getContactCreation('create_non_existing_contacts', integrationName),
    ]

    return (
      <div className={styles.root}>
        <IntegrationSyncDropdown
          integrationIcon={'activecampaignWithIcon'}
          iconHeight={90}
          isTwoWaySync={isTwoWaySync}
          syncType={syncType}
          setSyncType={setSyncType}
          selectItems={selectItems}
        />
        {isTwoWaySync &&
          CHECKBOXES.map(({ field, title, label }) => (
            <TitledRow
              key={field}
              title={title}
              label={label}
              verticalAlign={'start'}
              className={styles.titledRow}
            >
              <Switch size='middle' value={getCheckbox(field)} onChange={setCheckbox(field)} />
            </TitledRow>
          ))}
      </div>
    )
  }
)
